/**
 * Created by abhishek.panda on 18/10/17.
 */
import styled from "styled-components";

export const Flex = styled.div`
     display: flex;
     padding : ${(props)=>props.padding || "0px"};
     margin : ${(props)=>props.margin || "0px"};
     margin-top : ${(props)=>props.marginTop || "0px"}
`;

export const FlexCell = styled.div`
     flex: ${(props)=>props.flex || "1"};
     padding : ${(props)=>props.padding || "0px"};
     margin: ${(props)=>props.margin || ""};
`;